import React, { useState } from "react";

const ImageUpload = ({ value, onChange, disabled, onRemove }) => {
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files[0] && !disabled) {
      setIsUploading(true);
      try {
        await onChange(e);
      } catch (error) {
        console.error('Upload failed:', error);
      } finally {
        setIsUploading(false);
      }
    }
  };

  const renderSpinner = (className = "") => (
    <div className={`spinner-border spinner-border-sm ${className}`} role="status">
      <span className="visually-hidden">Uploading...</span>
    </div>
  );

  const containerStyle = {
    width: '60px',
    height: '60px'
  };

  const imageStyle = {
    width: '60px',
    height: '60px',
    objectFit: 'cover',
    cursor: disabled || isUploading ? 'default' : 'pointer'
  };

  const renderImagePreview = () => (
    <div className="position-relative">
      <label className="m-0 d-block">
        <img 
          src={value} 
          alt="Uploaded" 
          style={imageStyle} 
          className="d-block"
        />
        <input 
          type="file" 
          onChange={handleFileChange} 
          style={{ display: 'none' }} 
          disabled={disabled || isUploading} 
        />
      </label>
      {isUploading && (
        <div 
          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50"
          style={{ zIndex: 10 }}
        >
          {renderSpinner("text-white")}
        </div>
      )}
      {!disabled && !isUploading && onRemove && (
        <button 
          type="button" 
          className="btn-close position-absolute top-0 end-0 m-1 remove-image-btn"
          onClick={onRemove}
          aria-label="Close"
        />
      )}
    </div>
  );

  const renderUploadPlaceholder = () => (
    <label 
      className="d-flex align-items-center justify-content-center w-100 h-100 m-0"
      style={{ cursor: disabled || isUploading ? 'default' : 'pointer' }}
    >
      <input 
        type="file" 
        onChange={handleFileChange} 
        style={{ display: 'none' }} 
        disabled={disabled || isUploading} 
      />
      {isUploading ? (
        renderSpinner()
      ) : (
        <i 
          className="fa-regular fa-cloud-upload" 
          style={{ 
            fontSize: '24px',
            opacity: disabled ? 0.5 : 1
          }} 
          aria-hidden="true"
        />
      )}
    </label>
  );

  return (
    <div 
      className="position-relative border rounded image-upload"
      style={containerStyle}
    >
      {value ? renderImagePreview() : renderUploadPlaceholder()}
    </div>
  );
};

export default ImageUpload;